import 'scrolling-element'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
